(function () {
    'use strict';

    angular
        .module('app.admin')
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('home.adminNetworks', {
                    requireLogin: true,
                    url: 'admin/networks',
                    templateUrl: 'app/admin/networkManagement/networkManagement.html?app_v=deployDate',
                    controller: 'networkManagementCtrl',
                    data: {
                        authorizedRoles: ['Administrator', 'Achoo Analyst'],
                        navMarker: ['admin', 'networks']
                    }
                })
        }]);
})();